module.exports = __webpack_public_path__ + "img/icon_vcard.a73a988.svg";